import { AnalyticsInitialState, AnalyticsState } from 'apps/performanceAnalytics/store/types'

export const isQueryFilterless = (query: AnalyticsState['query']) =>
  query.contentType === AnalyticsInitialState.query.contentType &&
  query.automation === AnalyticsInitialState.query.automation &&
  query.sortField === AnalyticsInitialState.query.sortField &&
  query.sortOrder === AnalyticsInitialState.query.sortOrder
